/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorSpotlightProductTile_edge = {
    readonly cmsData: {
        readonly title: string | null;
    } | null;
    readonly node: {
        readonly localizedPdpUrl: string | null;
        readonly " $fragmentRefs": FragmentRefs<"LazyImageWrapper_item" | "ItemImage_item" | "Price_item">;
    } | null;
    readonly " $refType": "SbSharedCreatorSpotlightProductTile_edge";
};
export type SbSharedCreatorSpotlightProductTile_edge$data = SbSharedCreatorSpotlightProductTile_edge;
export type SbSharedCreatorSpotlightProductTile_edge$key = {
    readonly " $data"?: SbSharedCreatorSpotlightProductTile_edge$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedCreatorSpotlightProductTile_edge">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedCreatorSpotlightProductTile_edge",
  "type": "CmsItemsEdge",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cmsData",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedPdpUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "LazyImageWrapper_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemImage_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "Price_item",
          "args": [
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '99994c8a10903f10f5d82a6a5a63475f';
export default node;
